import React from 'react';
//import fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

function SideBar() {
    return (
        <>
            <aside id='sidebar' className='sidebar'>
                <ul className='sidebar-nav' id='sidebar-nav'>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/'>
                            <i className='bi bi-grid'></i>
                            <span>Dashboard</span>
                        </Link>
                    </li>                    
                    <li className='nav-item'>
                        <Link className='nav-link' to='/batch/list'>
                            <i className='bi bi-people'></i>
                            <span>My Batches</span>
                        </Link>
                    </li>  
                    <li className='nav-item d-none'>
                        <Link className='nav-link collapsed' data-bs-target="#batch-nav" data-bs-toggle="collapse" to='#'>
                            <i className="bi bi-people me-2"></i>
                            <span>Batches</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='batch-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                           
                            <li>
                                <Link to='/batch/list'>
                                    <i className='bi bi-arrow-right'></i>
                                    <span>Search Batch</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </aside>
        </>
    )
}

export default SideBar